module.exports = __webpack_public_path__ + "static/media/Winning sales-2.b54458cf.pdf";